import { REDUCERS, ACTION_CALL_ACD } from '../../constants.js';

const initialActionCallACD = {
  reducer_type: REDUCERS.REDUCER_ACTIOS_FROM_SM,
  callAction: "",
  parameters: {},
  callOutId: 0
};

const callActionsACD = (state = initialActionCallACD, action) => {
  if(ACTION_CALL_ACD[action.type]){
    return { callAction : ACTION_CALL_ACD[action.type], parameters : action.parameters, callOutId: action.callOutId };
  }
  return state;
}
export default callActionsACD;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_call_acd.js